import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ReCAPTCHA } from '@brokerbay/design-components';
import moment from 'moment';
import type { ExternalOfferState } from './ExternalOffer';

export interface ExternalOfferHeadingProps {
  state: ExternalOfferState;
  setState: React.Dispatch<React.SetStateAction<ExternalOfferState>>;
  canRegisterOffer: () => boolean;
  submit: (captchaResponse: string, captchaToken?: string) => void;
  validate: () => boolean;
}

const ExternalOfferHeading: React.FC<ExternalOfferHeadingProps> = ({
  state,
  setState,
  canRegisterOffer,
  submit,
  validate,
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmit = async (captchaResponse?: string) => {
    const hasError = validate();
    if (!hasError) {
      let captchaV3Token;
      // executeRecaptch can be undefined if script is not successfully loaded
      // in that case will open recaptcha to show challenge
      if (executeRecaptcha && !state.recaptchaOpen) {
        captchaV3Token = await executeRecaptcha('registerOffer');
      }

      if (captchaV3Token) {
        return submit(undefined, captchaV3Token);
      }

      if (captchaResponse) {
        return submit(captchaResponse);
      }

      return setState({
        ...state,
        recaptchaOpen: true,
      });
    }
  };

  return (
    <div className="hpanel">
      <div className="panel-body">
        <div className="external-offer-header">
          <div>
            <h2 className="font-bold m-b-xs">Offers</h2>
            <h2>
              <small>
                {state.listing.line1} {state.listing.line2}
              </small>
            </h2>
          </div>
          <div className="external-offer-header-button-container">
            {state.recaptchaOpen ? (
              <ReCAPTCHA
                data-cy="recaptcha-challenge"
                onChange={handleSubmit}
              />
            ) : (
              <>
                {canRegisterOffer() && (
                  <>
                    <div>
                      <button
                        className="btn btn-success"
                        onClick={() => handleSubmit()}
                        disabled={Object.values(state.error).some(Boolean)}
                        data-cy="register-offer"
                      >
                        Register Offer
                      </button>
                    </div>
                    <div>
                      <label className="external-offer-header-button-container-checkbox">
                        <input
                          checked={state.notifications.registeredOffers}
                          onChange={e =>
                            setState({
                              ...state,
                              notifications: {
                                ...state.notifications,
                                registeredOffers: e.target.checked,
                              },
                            })
                          }
                          type="checkbox"
                        />
                        Notify me regarding registered offers
                      </label>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExternalOfferHeading;
